<template>
  <div class="priceDetails">
    <VTableRemote
      ref="tableRemoteRef"
      :iconHeader="null"
      :isSearchable="false"
      :isSelectable="false"
      :items="allPricingPeriods"
      hideDefaultFooter
      :headers="tableHeaders"
      :pagination="{}"
      :centerColumns="['price']"
      :isInfinitScroll="true"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">
            <div class="pricingPeriod">
              <div :class="{manageNameColor: item.isNew, manageNameStyle: true}">
                {{ managedName === 'users' ? $t(`roles.${item.key}`) : item.key }}
              </div>
              <div
                v-if="item.isNew"
                class="pricingPeriodPoint"
              />
            </div>
          </td>
          <td class="text-center">
            <input
              v-if="isModeEdit"
              v-model="item.price"
              class="manualInputStyle"
              @input="patchPriceInput()"
            >
            <div v-else>
              {{ item.price }}
            </div>
          </td>
          <td />
        </tr>
      </template>
    </VTableRemote>
  </div>
</template>

<script>
import VTableRemote from '@/components/shared/content-views/VTableRemote.vue';
import { mapActions } from 'vuex';

export default {
    name: 'PriceDetails',
    components: { VTableRemote },
    props: {
        listManage: {
            type: Array,
            default: () => {},
        },
        managedName: {
            type: String,
            default: '',
        },
        pricingPeriod: {
            type: String,
            default: '',
        },
        isModeEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            allPricingPeriods: [],
        };
    },


    computed: {
        tableHeaders() {
            let headerManageName = this.managedName;
            if (this.managedName === 'users') {
                headerManageName = 'role';
            }
            if (this.managedName === 'features') {
                headerManageName = 'addOnFeature';
            }
            return [
                {
                    text: this.$t(`aquassistBilling.pricingManagement.labels.${headerManageName}`),
                    value: headerManageName,
                    sortable: false,
                    width: 300,
                    class: 'headManageSpacing',
                },
                {
                    text: this.$t('aquassistBilling.pricingManagement.labels.price'),
                    value: 'price',
                    sortable: false,
                },
                {
                    text: '',
                    value: 'none',
                    width: 300,
                    sortable: false,
                },
            ];
        },

    },

    created() {
        this.getPriceDetails();
    },

    methods: {
        ...mapActions({
            setPricingPeriodUpdatedData: 'setPricingPeriodUpdatedData',
        }),
        getPriceDetails() {
            this.isFetching = true;
            this.allPricingPeriods = this.listManage;
            this.isFetching = false;
        },
        patchPriceInput() {
            const payload = { pricingPeriodId: this.pricingPeriod, params: { [this.managedName]: [...this.listManage] } };
            this.setPricingPeriodUpdatedData({ pricingPeriodUpdatedData: payload });
        },
    },
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/pricingManagement.scss";
.custom-table .v-data-table__wrapper table td:first-child:not(.v-data-table__mobile-row){
    border-left: 8px solid #b9d4f9 !important;
}
::v-deep .blocHeader{
    height: 0;
}
.pricingPeriod{
    column-gap: 1rem;
}
::v-deep .v-data-table-header{
    position: sticky;
}
::v-deep .custom-table .v-data-table__wrapper table td{
    height: 3rem;
}
::v-deep .custom-table .v-data-table__wrapper{
    height: auto !important;
    max-height: 400px;
}
::v-deep .headManageSpacing span {
    padding-left: 2rem;
}
</style>
